import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailDomainValidator(control: AbstractControl): ValidationErrors | null {
  const email = control.value;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (email && !emailRegex.test(email)) {
    return { invalidEmailDomain: true };
  }

  return null;
}

export function fileSizeValidator(maxMB: number): ValidatorFn {
  const maxBytes = maxMB * 1024 * 1024;
  return (control: AbstractControl) => {
    const file = control.value;
    if (!file || !(file instanceof File)) return null;

    if (file.size > maxBytes) {
      return { maxSizeExceeded: true };
    }

    return null;
  };
}

export function mimeTypeValidator(allowedTypes: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value;

    if (!file || !(file instanceof File)) {
      return null;
    }

    return allowedTypes.includes(file.type) ? null : { invalidMimeType: { actual: file.type, allowed: allowedTypes } };
  };
}

export function passwordsMatchValidator(passwordKey: string, confirmPasswordKey: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const group = formGroup as FormGroup;
    const passwordControl = group.get(passwordKey);
    const confirmPasswordControl = group.get(confirmPasswordKey);

    if (!passwordControl || !confirmPasswordControl) {
      return null;
    }

    const password = passwordControl.value;
    const confirmPassword = confirmPasswordControl.value;

    if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
      return null;
    }

    if (password !== confirmPassword) {
      confirmPasswordControl.setErrors({ ...confirmPasswordControl.errors, passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      const errors = confirmPasswordControl.errors;
      if (errors) {
        delete errors['passwordMismatch'];
        if (Object.keys(errors).length === 0) {
          confirmPasswordControl.setErrors(null);
        } else {
          confirmPasswordControl.setErrors(errors);
        }
      }
    }

    return null;
  };
}

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;

  if (!value) return null;

  const localPart = '[a-zA-Z0-9._%+-]+';
  const atSymbol = '@';
  const domain = '[a-zA-Z0-9-]+';
  const dotCom = '\\.com';
  const optionalBr = '(\\.br)?';
  const fullRegex = `^${localPart}${atSymbol}${domain}${dotCom}${optionalBr}$`;

  const emailRegex = new RegExp(fullRegex, 'i');

  return emailRegex.test(value) ? null : { invalidEmail: true };
}
